import React from 'react';
import { Target as LucideTarget } from 'lucide-react';

interface TargetProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Target: React.FC<TargetProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideTarget width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default Target;
